export const DeviceAlertModel = {
    name: "",
    description: "",
    model: "",
    has_not_send: false,
    days: 3,
    has: {},
    values: {},
};
